/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBurstingDefinitionShortcut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M6.492 3.145a1 1 0 0 1 1.037 0l5.01 3.037a1 1 0 0 1 .482.855v2.974l3.472-2.104a1 1 0 0 1 1.036 0l5.011 3.037a1 1 0 0 1 .482.855v4.859a1 1 0 0 1-.482.855l-5.01 3.037a1 1 0 0 1-1.037 0l-5.01-3.037a1 1 0 0 1-.483-.855v-2.974l-3.47 2.103a1 1 0 0 1-1.037 0l-5.01-3.036A1 1 0 0 1 1 11.896v-4.86a1 1 0 0 1 .482-.854zm-.481 10.012v-2.52L3 8.812v2.52zm2 0 3.01-1.825v-2.52l-3.01 1.825zm-1-4.253 3.08-1.867-3.08-1.868-3.082 1.868zm9 9.015V15.4l-3.01-1.825v2.52zm2 0 3.01-1.825v-2.52l-3.01 1.825zm-1-4.253 3.081-1.867-3.08-1.867-3.082 1.867zM2.474 17.474 1 16h5v5l-1.653-1.653c-1.27.777-1.936 1.982.672 3.653 0 0-4.56-.436-3.298-4.29 0 0 .18-.576.753-1.236z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBurstingDefinitionShortcut as BurstingDefinitionShortcut };
